export default __webpack_public_path__ + "static/media/air-consumed-icon.fab82c91.svg";